import { render, staticRenderFns } from "./advert-equipment.vue?vue&type=template&id=f6ff72ce"
import script from "./advert-equipment.vue?vue&type=script&lang=ts"
export * from "./advert-equipment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports